import React from 'react';

interface DebugToggleProps {
  onClick: () => void;
  isActive: boolean;
}

const DebugToggle: React.FC<DebugToggleProps> = ({ onClick, isActive }) => {
  return (
    <button 
      className={`fixed bottom-5 right-5 w-14 h-14 rounded-full ${
        isActive ? 'bg-green-600 hover:bg-green-700' : 'bg-indigo-600 hover:bg-indigo-700'
      } border-none text-white cursor-pointer flex items-center justify-center shadow-lg transition-all duration-300 z-[10000] hover:scale-110 hover:shadow-xl active:scale-95`}
      onClick={onClick}
      aria-label="Toggle debug panel"
      title="Toggle debug panel"
    >
      <svg 
        width="28" 
        height="28" 
        viewBox="0 0 24 24" 
        fill="none" 
        stroke="currentColor" 
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      >
        <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
        <line x1="9" y1="9" x2="15" y2="9" />
        <line x1="9" y1="15" x2="15" y2="15" />
      </svg>
    </button>
  );
};

export default DebugToggle;
